const contractTypes = [
  {
    name: "Full time",
    value: "FULL_TIME",
  },
  {
    name: "Part time",
    value: "PART_TIME",
  },
  {
    name: "No contract",
    value: "NO_CONTRACT",
  },
  {
    name: "Freelancer",
    value: "FREELANCER",
  },
  {
    name: "Seasonal",
    value: "SEASONAL",
  },
  {
    name: "Contract",
    value: "CONTRACT",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

export default contractTypes;
